import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LetterCanvas from '../molecules/LetterCanvas';
import ActionButton from '../atoms/ActionButton';
import ShareLinks from '../molecules/ShareLinksBK';
import Ads from '../atoms/Ads';
import { useLetterStore } from '../../store/letterStore';
import TemplateController from '../molecules/TemplateController';
import { supabase } from '../../lib/supabaseClient';
import BackButton from '../atoms/BackButton';
import Terms2 from '../organisms/Terms';
import ShareModal from '../organisms/ShareModal';

const EditView: React.FC = () => {
  const { letterData } = useLetterStore();
  const navigate = useNavigate();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [letterId, setLetterId] = useState('');

  // letterDataがnullの場合はデフォルト値を設定
  const defaultLetterData = {
    from_name: '',
    to_name: '',
    message: '',
    date: '',
    template_name: 'letter-template01.jpg',
    end_date: '',
  };

  const currentLetterData = letterData || defaultLetterData;

  const [template, setTemplate] = useState(
    currentLetterData.template_name || 'letter-template01.jpg'
  );

  console.log('letterData', letterData);

  const [downloadURL, setDownloadURL] = useState('#');
  const [randomMessageDisable, setRandomMessageDisable] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const changeTemplate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const id = parseInt(e.target.value);
  };

  const changeFrom = (e: React.ChangeEvent<HTMLInputElement>) => {};

  const changeTo = (e: React.ChangeEvent<HTMLInputElement>) => {};

  const changeMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {};

  const handleOutput = (url: string) => {
    setDownloadURL(url);
  };

  const makeLetterAgain = () => {
    navigate('/question');
  };

  const saveCanvas = () => {
    const canvas = document.getElementById('js-canvas') as HTMLCanvasElement;
    if (!canvas) return;

    const imageType = 'image/png';
    const fileName = 'letter.png';
    const base64 = canvas.toDataURL(imageType);
    const blob = Base64toBlob(base64);
    saveBlob(blob, fileName);
  };

  const Base64toBlob = (base64: string) => {
    const tmp = base64.split(',');
    const data = atob(tmp[1]);
    const mime = tmp[0].split(':')[1].split(';')[0];
    const buf = new Uint8Array(data.length);
    for (let i = 0; i < data.length; i++) {
      buf[i] = data.charCodeAt(i);
    }
    const blob = new Blob([buf], { type: mime });
    return blob;
  };

  const saveBlob = (blob: Blob, fileName: string) => {
    const url = window.URL || window.webkitURL;
    const dataUrl = url.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = fileName;
    a.click();
  };

  const sendMessage = async () => {
    if (!letterData) {
      console.error('Letter data is not available');
      return;
    }

    setIsSending(true);
    try {
      const { data, error } = await supabase
        .from('letters')
        .insert([
          {
            from_name: letterData.from_name,
            to_name: letterData.to_name,
            message: letterData.message,
            date: letterData.date,
            template_name: letterData.template_name,
            end_date: letterData.end_date,
          },
        ])
        .select();

      if (error) {
        console.error('Error inserting letter:', error);
        console.log('メッセージの送信に失敗しました。');
        return;
      }

      console.log('Letter inserted successfully:', data);

      // 送信成功後、作成されたletterのIDを使ってletterページに遷移
      if (data && data.length > 0) {
        setLetterId(data[0].id);
        setIsShareModalOpen(true);
      } else {
        window.alert('メッセージが正常に送信されました！');
      }
    } catch (error) {
      console.error('Unexpected error:', error);
      window.alert('予期しないエラーが発生しました。');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div id='page' className='lower-page'>
      <header className='l-header p-header'>
        <h1 className='p-header__logo'>
          <Link to='/'>
            <img src='/img/common/logo.png' alt='SKALE' />
          </Link>
        </h1>
      </header>

      <div id='contents'>
        <div className={`c-container u-mt50`}>
          <LetterCanvas
            template_file_name={template}
            from_name={currentLetterData.from_name || ''}
            to_name={currentLetterData.to_name || ''}
            message={currentLetterData.message || ''}
            date={currentLetterData.date || ''}
            onOutput={handleOutput}
          />

          <TemplateController onTemplateChange={setTemplate} />
        </div>

        <div className='c-container u-mt50 c-btn-rows'>
          <BackButton size='small' onClick={() => navigate('/message')}>
            戻る
          </BackButton>
          <ActionButton size='small' onClick={sendMessage} disabled={isSending}>
            {isSending ? '送信中...' : 'メッセージ送信'}
          </ActionButton>
        </div>
      </div>

      <ShareModal
        open={isShareModalOpen}
        letterId={letterId}
        fromName={currentLetterData.from_name || ''}
        onClose={() => setIsShareModalOpen(false)}
      />

      <footer className='l-footer p-footer'>
        <Ads />
      </footer>
    </div>
  );
};

export default EditView;
